import * as Actions from './admin.actions';

const initialState = {
  isAllFeaturesEnabled: false,
};

export const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_ENABLE_ALL_FEATURES:
      return {
        ...state,
        isAllFeaturesEnabled: action.isEnabled,
      };
    default:
      return state;
  }
};

export { namespace } from './admin.reducer.metadata';
